export default function () {
  const widgetName = "clientPortfolioFeature";
  const widgetOpts = clientPortfolioFeatureOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    maxItemsVisible: 6,
    itemsPerPanel: 6,
    hasImages: true,
    lazyLoadImages: true,
    textOverImage: false,
    showDescription: true,
    buyNowButton: false,
    imageIsBackground: false,
    moreButton: {
      visible: true,
      text: "",
    },

    link: [""],

    cardWidgetLoaded: function (data) {
      const widgetData = data.items;
      if (widgetData.length < 1) {
        $(`#${widgetName}`).remove();
      } else {
        customWidget(widgetData);
      }
    },
  });

  function customWidget(widgetData) {
    $(`#${widgetName} .card-widget-item`).each(function (x) {
      let $portfolioItem = $(this);
      const { DetailLinkText, URL } = widgetData[x];
      let jobTitle = URL.split("/")[2];

      $portfolioItem.attr({
        "data-aos": "flip-left",
        "data-aos-easing": "ease-in-out",
        "data-aos-duration": "180",
        "data-aos-delay": (x + 1) * 250,
        "data-aos-once": "true",
        "data-aos-offset": "200",
      });

      $portfolioItem
        .find(".card-widget-title, .card-widget-description")
        .wrapAll('<div class="card-content-up">');

      $portfolioItem
        .find(".buttonwrap")
        .append(`<span class="job-name">${jobTitle}</span>`);
      $portfolioItem
        .find(".moreButton")
        .replaceWith(`<span class="job-title">${DetailLinkText}</span>`);
    });
  }
}
